import { API } from "@/main.js";

const getDefaultState = () => {
  return {};
};

const state = getDefaultState();

const getters = {};

const mutations = {};

const actions = {
  RUN_NETWORK_CALCULATION({ commit }, data) {
    return new Promise((resolve, reject) => {
      API.workspace_design.runNetworkCalculation(
        data.endpoint,
        data.data,
        resp => {
          resolve(resp);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  fetchValidations({ commit }) {
    return new Promise((resolve, reject) => {
      API.workspace_design.fetchValidations(
        resp => {
          resolve(resp.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  runNetworkValidation({ commit }, data) {
    return new Promise((resolve, reject) => {
      API.workspace_design.runNetworkValidation(
        data.endpoint,
        data.technicalLocalUUID,
        resp => {
          resolve(resp);
        },
        error => {
          reject(error);
        }
      );
    });
  }
};

export default { state, getters, actions, mutations };



// WEBPACK FOOTER //
// ./src/store/modules/Home/calculations.js